<template>
  <div style="width: 100%;">
    <div v-if="!show_gif && !getIsFreeLimitReached" class="columns is-mobile" style="margin-left: 10px;margin-top: 25px;">
      <button v-if="!quizOver" id="submitButton" type="button" @click="submitAnswer()" class="button is-primary is-medium" :disabled="isLoadingQuestionSubmit">
        {{!isLoadingQuestionSubmit ? "Submit Answer" : "Please wait..."}}
      </button>
      <audio v-if="tingAudioURL" :src="tingAudioURL" id="audio" ref="tingAudio" preload="auto" @error="handleAudioError"></audio>
      <audio v-if="wrongAudioURL" :src="wrongAudioURL" id="wrongAudio" ref="wrongAudio" preload="auto" @error="handleAudioError"></audio>
    </div>
    <!--Animated GIF for correct/incorrect answer-->
    <div v-if="show_gif" class="columns is-vcentered is-multiline">
      <div class="column is-7">
        <p class="has-text-centered title is-2 kid-font">
          {{ randomPhrase }}
        </p>
      </div>
      <div class="column is-5 has-text-centered">
        <img style="max-height: 150px" :src="animated_gif" />
      </div>
      <!--Explanations for incorrect answer-->
      <div class="column is-12 has-text-centered">
        <div v-if="!isCurrentAnswerCorrect && (hasExplanationContent || currentQuestion.explanation_custom_layout)" class="explanation-box">
          <p class="title is-5 has-text-centered">Explanation</p>
          
          <!-- HTML Explanation -->
          <div v-if="hasExplanationContent" class="explanation" v-html="currentQuestion.explanation"></div>
          
          <!-- Custom Layout Explanation -->
          <div v-if="currentQuestion.explanation_custom_layout" class="explanation-custom-layout mt-3">
            <show-custom-layout
              :custom_layout="currentQuestion.explanation_custom_layout"
              :outer_width="'100%'"
              :is_outer_height_extra="false"
            ></show-custom-layout>
          </div>
        </div>
      </div>

      <!--Showing next button if quiz not over and ans is wrong-->
      <div v-if="!quizOver && !isCurrentAnswerCorrect" class="column is-12 has-text-centered">
        <b-button @click="nextQuestion()" class="mx-1" type="is-primary" size="is-medium"
          icon-right="chevron-right">Next</b-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ShowCustomLayout from "@/components/Question/CustomLayout/ShowCustomLayout";
const tingSound = require("@/assets/music/ting.mp3")
const wrongSound = require("@/assets/music/wrong.mp3")

export default {
  name: "bottom-navigator",
  components: {
    ShowCustomLayout,
  },
  props: {
    currentQuestion: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoadingQuestionSubmit : false,
      isCurrentAnswerCorrect: false,
      show_gif: false,
      animated_gif: null,
      correct_phrases: [
        "Great !",
        "Wonderful !",
        "Excellent !",
        "Fantastic !",
        "You've Got It !",
        "Amazing !",
        "Awesome !",
        "Well Done !",
        "Exceptional !",
        "Terrific !",
        "Superb !",
        "Outstanding !",
        "Fantastic !",
        "Very Good !",
        "Marvelous !",
        "Great Answer !",
        "Magnificent !",
        "Clever !",
        "Brilliant !",
        "Phenomenal !",
        "Great !",
        "Brilliant !",
        "Correct !",
        "Impressive !",
        "That's Right !",
        "Keep it Up !",
        "Incredible !",
        "Nice Going !",
        "Spectacular !",
        "Bravo !",
      ],
      incorrect_phrases: [
        "Sorry - Incorrect Answer !",
        "Sorry - Your Answer is Incorrect !",
        "Oops - Incorrect Answer !",
        "Sorry - Wrong Answer !",
      ],
      tingAudioURL: null,
      wrongAudioURL: null
    };
  },
  methods: {
    ...mapActions([
      "updateCurrentQuestionIndex",
      "updateQuestionResponse",
      "appendQuestionToList",
      "toggleSubscribeModal",
      "toggleFreeLimitReached"
    ]),
    playTingSound() {
      try {
        this.tingAudioURL = tingSound;
        this.$nextTick(() => {
          if (this.$refs.tingAudio) {
            // Reset and play the audio
            this.$refs.tingAudio.currentTime = 0;
            this.$refs.tingAudio.play().catch(error => {
              console.warn('Audio play failed:', error);
              // Fallback: try to play with a new audio instance
              this.playTingSoundFallback();
            });
          } else {
            // Fallback if ref is not available
            this.playTingSoundFallback();
          }
        });
      } catch (error) {
        console.warn('Audio setup failed:', error);
        this.playTingSoundFallback();
      }
    },
    playTingSoundFallback() {
      try {
        const audio = new Audio(tingSound);
        audio.play().catch(error => {
          console.warn('Fallback audio play failed:', error);
        });
      } catch (error) {
        console.warn('Fallback audio creation failed:', error);
      }
    },
    playWrongSound() {
      try {
        this.wrongAudioURL = wrongSound;
        this.$nextTick(() => {
          if (this.$refs.wrongAudio) {
            // Reset and play the audio
            this.$refs.wrongAudio.currentTime = 0;
            this.$refs.wrongAudio.play().catch(error => {
              console.warn('Wrong audio play failed:', error);
              // Fallback: try to play with a new audio instance
              this.playWrongSoundFallback();
            });
          } else {
            // Fallback if ref is not available
            this.playWrongSoundFallback();
          }
        });
      } catch (error) {
        console.warn('Wrong audio setup failed:', error);
        this.playWrongSoundFallback();
      }
    },
    playWrongSoundFallback() {
      try {
        const audio = new Audio(wrongSound);
        audio.play().catch(error => {
          console.warn('Fallback wrong audio play failed:', error);
        });
      } catch (error) {
        console.warn('Fallback wrong audio creation failed:', error);
      }
    },
    checkCustomLayoutObject(object) {
      let is_correct = true;
      if (object.type == "INPUT") {
        let is_input_valid = false;
        if (object.response) {
          if (object.answer_not_exactly_same) {
            let user_response_no_space = object.response
              .replace(/\s/g, "")
              .toLowerCase();
            let answer_no_space = object.answer
              .replace(/\s/g, "")
              .toLowerCase();

            is_input_valid = user_response_no_space == answer_no_space;
          } else {
            is_input_valid = object.response == object.answer;
          }
        }

        if (!is_input_valid) {
          is_correct = false;
        }
      } else if (object.type == "MULTI-CHARS") {
        let has_inps = false;
        for (let row of object.multi_chars.data) {
          for (let col of row) {
            if (col.type == "I") {
              has_inps = true;
              break;
            }
          }
          if (has_inps) {
            break;
          }
        }

        if (has_inps) {
          is_correct = object.is_correct;
        }
      }
      return is_correct;
    },
    checkCustomLayoutObjects(objects) {
      // Assuming that initially correct
      let is_correct = true;
      for (let object of objects) {
        is_correct = this.checkCustomLayoutObject(object);
        if (!is_correct) {
          break;
        }
      }

      return is_correct;
    },
    checkCurrentAnswer() {
      // Assuming the answers are correct
      let is_correct = true;
      // Checking for custom layout, This has to be on the top
      if (this.currentQuestion.custom_layout) {
        let is_correct_local = true;
        //Checking for Custom Layout
        if (this.fetchCurrentAnswer.custom_layout.objects) {
          // If answer is added
          is_correct_local = this.checkCustomLayoutObjects(
            this.fetchCurrentAnswer.custom_layout.objects
          );
        } else {
          // If inputs is present but no answer
          let num_inputs_in_cl =
            this.currentQuestion.custom_layout.objects.filter((obj) =>
              ["INPUT", "MULTI-CHARS"].includes(obj.type)
            ).length;
          if (num_inputs_in_cl) {
            is_correct_local = false;
          }
        }

        if (!is_correct_local) return false; // Return false if wrong answer
      }

      if (this.currentQuestion.type == "DQ") {
        //Checking for descriptive 2 conditions
        if (this.currentQuestion.descriptive.answer_not_exactly_same) {
          let user_response_no_space = this.fetchCurrentAnswer.dq
            .replace(/\s/g, "")
            .toLowerCase();
          let answer_no_space = this.currentQuestion.descriptive.answer
            .replace(/\s/g, "")
            .toLowerCase();
          is_correct = user_response_no_space == answer_no_space;
        } else {
          is_correct =
            this.fetchCurrentAnswer.dq ==
            this.currentQuestion.descriptive.answer;
        }
      } else if (this.currentQuestion.type == "TF") {
        //Checking for true/false
        is_correct =
          this.fetchCurrentAnswer.tf == this.currentQuestion.tf.answer;
      } else if (this.currentQuestion.type == "MCQ") {
        if (
          this.fetchCurrentAnswer.options.length !==
          this.currentQuestion.mcq.answer.length
        )
          return false;

        //Matching all options in the responses with the answer
        for (let response of this.fetchCurrentAnswer.options) {
          if (!this.currentQuestion.mcq.answer.includes(response)) {
            return false;
          }
        }
      } else if (this.currentQuestion.type == "ORDERING") {
        //Checking for ORDERING
        let multiple_mapping = {};
        const orders = this.currentQuestion.ordering.options.map((option) => {
          return { name: option.name.toUpperCase(), order: option.order };
        });
        for (let row of orders) {
          if (!multiple_mapping[row.name]) multiple_mapping[row.name] = [];
          multiple_mapping[row.name].push(row.order);
        }

        let current_order = [];
        for (let row of orders) {
          current_order.push(multiple_mapping[row.name]);
        }
        // console.log({options : this.currentQuestion.ordering.options, current_order})
        if (!this.$common.checkArraySortedOrderingQuestions(current_order))
          return false;
      } else if (this.currentQuestion.type == "DRAGDROP") {
        //Checking for Drag & Drop
        if (!this.fetchCurrentAnswer.drag_drop) return false;
      } else if (this.currentQuestion.type == "MATCHING") {
        if (!this.fetchCurrentAnswer.matching) return false;
      } else if (this.currentQuestion.type == "PATTERN") {
        //Checking for Pattern
        for (let pattern_layer_index in this.currentQuestion.pattern.layers) {
          const layer =
            this.currentQuestion.pattern.layers[pattern_layer_index];
          for (let column_index in layer.columns) {
            const column = layer.columns[column_index];
            if (column.type == "USERINP") {
              const response =
                this.fetchCurrentAnswer.pattern?.layers?.[pattern_layer_index]?.[column_index];
              if (
                (column.clipart != -1 && response != column.clipart) ||
                (column.clipart == -1 && response != undefined)
              )
                return false;
            }
          }
        }
      } else if (this.currentQuestion.type == "DIVIDER") {
        if (!this.fetchCurrentAnswer.divider.length) return false;
      }

      // Checking Line Chart
      if (
        this.currentQuestion.line_chart &&
        this.currentQuestion.line_chart.is_user_select_points
      ) {
        if (!this.fetchCurrentAnswer.line_chart) return false;
      }

      // Checking Bar Chart
      if (
        this.currentQuestion.bar_chart &&
        this.currentQuestion.bar_chart.type &&
        this.currentQuestion.bar_chart.properties.length &&
        this.currentQuestion.bar_chart.properties.find(
          (r) => r.is_user_select_points
        )
      ) {
        if (!this.fetchCurrentAnswer.bar_chart) return false;
      }

      //Checking Protractor
      if (
        this.currentQuestion.protractor &&
        this.currentQuestion.protractor.is_user_selectable
      ) {
        if (!this.fetchCurrentAnswer.protractor) return false;
      }

      //Checking Venn Diagram
      if (
        this.currentQuestion.venn_diagram &&
        this.currentQuestion.venn_diagram.properties.filter(
          (property) => property.is_draggable
        ).length
      ) {
        if (!this.fetchCurrentAnswer.venn_diagram) return false;
      }

      //Checking Color Grid
      if (this.currentQuestion.color_grid) {
        if (!this.fetchCurrentAnswer.color_grid) return false;
      }

      //Checking Clipart Table
      if (this.currentQuestion.clipart_table) {
        if (!this.fetchCurrentAnswer.clipart_table) return false;
      }

      //Checking Number Line
      if (this.currentQuestion.number_line) {
        //Check its answer for inputs
        if (
          this.currentQuestion.number_line.inputs &&
          this.currentQuestion.number_line.inputs.length
        ) {
          // Check if all the inputs are filled, if not then is_correct = false
          if (!this.fetchCurrentAnswer.number_line) return false;

          let nl_answer_inputs = this.fetchCurrentAnswer.number_line.input;

          if (!nl_answer_inputs || !Object.keys(nl_answer_inputs).length)
            return false;

          if (
            Object.keys(nl_answer_inputs).length !=
            this.currentQuestion.number_line.inputs.length
          )
            return false;

          const not_exact = this.currentQuestion.number_line
            .answer_not_exactly_same;

          for (let input_key in nl_answer_inputs) {
            const user_val = nl_answer_inputs[input_key];

            if (not_exact) {
              // Ignore whitespace & case (same logic as custom layout INPUTs)
              const user_norm = String(user_val == null ? "" : user_val)
                .replace(/\s/g, "")
                .toLowerCase();
              const key_norm = String(input_key)
                .replace(/\s/g, "")
                .toLowerCase();
              if (!user_norm || user_norm != key_norm) {
                return false;
              }
            } else {
              // Check if key and val are same, if not return false
              if (input_key != user_val) {
                return false;
              }
            }
          }
        }

        //Check its answer for selects
        if (this.currentQuestion.number_line.allow_select) {
          // Clicked responses of user
          const nl_answer_selects = this.fetchCurrentAnswer.number_line
            ? Object.values(
              this.fetchCurrentAnswer.number_line.selected
            ).filter((obj) => obj.clicked)
            : [];

          // Numbers allowed to be clicked for answer
          const nums_allow_clicked =
            this.currentQuestion.number_line.numbers.filter(
              (obj) => obj.is_select_answer
            );

          if (nl_answer_selects.length != nums_allow_clicked.length)
            return false;

          for (let num_obj of nums_allow_clicked) {
            if (num_obj.is_select_answer) {
              const num = num_obj.number;
              // Finding the number in answer if selected
              const num_ans_obj = nl_answer_selects.find(
                (obj) => obj.num == num
              );
              if (!num_ans_obj.clicked) return false;
            }
          }
        }
      }

      //Checking whether the clipart layer add remove is equal to max row
      for (let layer of this.currentQuestion.layers) {
        if (layer.allow_add_remove && layer.number != layer.max_display) {
          return false;
        }
      }

      //Checking the answer for table inputs
      if (this.currentQuestion.tables && this.fetchCurrentAnswer.tables) {
        let input_cells_count = 0;
        let actual_click_cells = [];
        for (let table_i in this.currentQuestion.tables) {
          let table_obj = this.currentQuestion.tables[table_i];
          //Finding all cells of type = INPUT
          for (let row_i in table_obj.data) {
            let table_row = table_obj.data[row_i];
            for (let col_i in table_obj.columns) {
              let table_cell = table_row[col_i];
              if (table_cell.type == "INPUT") {
                input_cells_count += 1;
              }
              if (table_cell.is_select_answer) {
                let cell_key = `${table_i}-${row_i}-${col_i}`;
                actual_click_cells.push(cell_key);
              }
            }
          }
        }

        let response_key_count = Object.keys(
          this.fetchCurrentAnswer.tables.data
        ).length;
        if (response_key_count !== input_cells_count) return false;

        for (let response_key in this.fetchCurrentAnswer.tables.data) {
          if (
            !this.checkCustomLayoutObject(
              this.fetchCurrentAnswer.tables.data[response_key]
            )
          )
            return false;
        }

        // Checking for clicked data
        if (actual_click_cells.length) {
          if (
            actual_click_cells.length !==
            Object.keys(this.fetchCurrentAnswer.tables.clicked).length
          )
            return false;

          for (let actual_click_key of actual_click_cells) {
            if (!this.fetchCurrentAnswer.tables.clicked[actual_click_key])
              return false;
          }
        }
      }

      return is_correct;
    },
    nextQuestion() {
      if (this.fetchCurrentQuestionIndex != this.fetchQuestions.length - 1) {
        this.updateCurrentQuestionIndex(this.fetchCurrentQuestionIndex + 1);
      }
      this.show_gif = false;
      // this.tingAudioURL = null
    },
    loadAnimatedGif() {
      const no_gif_images = 4;
      const gif_index = Math.floor(Math.random() * no_gif_images) + 1;
      const filename_prefix = this.isCurrentAnswerCorrect
        ? "dancing_panda"
        : "thinking_panda";
      this.animated_gif = require(`@/assets/images/gif/${filename_prefix}${gif_index}.gif`);
    },
    submitAnswer() {

      // Checking if the current question is attempted
      if(this.fetchQuestionResponseMappings[this.fetchCurrentQuestionIndex]){
        return this.$buefy.toast.open({
          message: "You cannot reattempt this question",
          type: "is-danger",
        });
      }

      this.isLoadingQuestionSubmit = true

      if (this.currentQuestion.type == "ORDERING") {
        this.fetchCurrentAnswer = this.isCurrentAnswerCorrect;
      }

      this.isCurrentAnswerCorrect = this.checkCurrentAnswer();

      // Sending the response and if wrong then store in state
      this.updateQuestionResponse({
        token: this.getTeacherToken,
        question_id: this.currentQuestion._id,
        index: this.fetchCurrentQuestionIndex,
        response: {
          kid: this.$route.params.kid_id,
          is_correct: this.isCurrentAnswerCorrect,
          response: this.fetchCurrentAnswer,
        },
      }).then(() => {
        //Loading the gif
        this.loadAnimatedGif();
        //Finalling showing the gif
        this.show_gif = true;

        // If wrong answer, then append the question again for student to reattempt
        if (!this.isCurrentAnswerCorrect) {
          this.playWrongSound();
          this.appendQuestionToList(this.currentQuestion._id);
        }else{
          this.playTingSound()
          setTimeout(() => {
            this.nextQuestion()
          }, 2000)
        }
      }).catch(err => {
        if(err.response.data && err.response.data.subscribe){
          this.toggleSubscribeModal(true)
          this.toggleFreeLimitReached(true)
        }
      }).finally(() => {
        this.isLoadingQuestionSubmit = false
      })
    },
    handleAudioError() {
      console.warn('Audio error:', 'An error occurred while playing the audio.');
    },
  },
  computed: {
    ...mapGetters([
      "getTeacherToken",
      "fetchQuestions",
      "fetchCurrentQuestionIndex",
      "fetchQuestionResponseMappings",
      "fetchCurrentAnswer",
      "getIsOpenSubscribeModal",
      "getIsFreeLimitReached"
    ]),
    hasExplanationContent() {
      return this.currentQuestion.explanation && this.currentQuestion.explanation.trim().length > 0;
    },
    upScore() {
      let mapping = {};
      for (let q of this.fetchQuestions) {
        mapping[q._id] = 1;
      }
      return Math.round(
        (this.questionsCorrect / Object.keys(mapping).length) * 100
      );
    },
    questionsCorrect() {
      // Unique questions correct
      let num = 0;
      // converting the mapping of index to question id
      let questionIdMapping = {};
      for (let question_index in this.fetchQuestionResponseMappings) {
        const mappingValue = this.fetchQuestionResponseMappings[question_index];
        questionIdMapping[mappingValue.question] = mappingValue;
      }

      for (let question_index in questionIdMapping) {
        if (questionIdMapping[question_index].is_correct) {
          num++;
        }
      }

      return num;
    },
    randomPhrase() {
      return this.isCurrentAnswerCorrect
        ? this.correct_phrases[
        Math.floor(Math.random() * this.correct_phrases.length)
        ]
        : this.incorrect_phrases[
        Math.floor(Math.random() * this.incorrect_phrases.length)
        ];
    },
    questionsAnswered() {
      //Returns number of questions answered
      return (Object.keys(this.fetchQuestionResponseMappings)).length
    },
    quizOver() {
      return (this.questionsAnswered == this.fetchQuestions.length) && (this.upScore == 100);
    },
  },
  watch: {
    fetchCurrentQuestionIndex() {
      // Setting default current answer to false
      this.isCurrentAnswerCorrect = false;
    },
  },
  mounted: function () {
    this.$nextTick(() => {
      // Preload the ting sound for better performance
      try {
        const audio = new Audio(tingSound);
        audio.preload = 'auto';
        audio.load();
      } catch (error) {
        console.warn('Audio preload failed:', error);
      }

      // Preload the wrong sound for better performance
      try {
        const wrongAudio = new Audio(wrongSound);
        wrongAudio.preload = 'auto';
        wrongAudio.load();
      } catch (error) {
        console.warn('Wrong audio preload failed:', error);
      }

      // document.addEventListener("keydown", (e) => {
      //   if (e.key === "ArrowRight")
      //     this.nextQuestion();
      // })
      document.addEventListener("keypress", (e) => {
        if (e.key === "Enter")
          console.log("Enter pressed")
          // this.submitAnswer();
      })
    })
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap");

.explanation-box {
  background-color: #f8f9ff;
  border: 2px solid #e2e5ff;
  border-radius: 10px;
  padding: 1.25rem;
  margin: 1rem 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.explanation {
  font-size: 1.35rem;
  line-height: 1.6;
  color: #333;
  font-family: 'Source Sans Pro', sans-serif;
  margin-top: 0.75rem;
  text-align: left;
}

.explanation-box .title.is-5 {
  color: #8919e7;
  font-weight: 700;
  border-bottom: 1px solid #e2e5ff;
  padding-bottom: 0.5rem;
  margin-bottom: 0.75rem;
  font-size: 1.5rem;
}

/* Preserve whitespace in explanation content */
.explanation,
.explanation p,
.explanation div {
  white-space: pre-wrap;
}

/* Hide drag/resize handles in explanation */
.explanation-custom-layout .vdr-stick {
  display: none !important;
}

/* Contain custom layout within explanation box */
.explanation-custom-layout {
  overflow: auto;
  max-width: 100%;
}
</style>